import {createSelector} from 'reselect';
import Language from '../lang/language';
import getIsCollectionEnabled from './getIsCollectionEnabled';
import {getDeliveryType, getSiteCode} from './selectors';

export default key => createSelector(
  [getIsCollectionEnabled, getDeliveryType, getSiteCode],
  (isCollectionEnabled, deliveryType, siteCode) => {
    if (isCollectionEnabled && deliveryType === 'pudo') {
      const siteSpecificPudoKey = `${key}.pudo.${siteCode}`;
      return Language.doesTranslationExist(siteSpecificPudoKey)
        ? siteSpecificPudoKey
        : `${key}.pudo`;
    }
    
    const siteSpecificDeliveryKey = `${key}.${siteCode}`;
    
    return Language.doesTranslationExist(siteSpecificDeliveryKey)
      ? siteSpecificDeliveryKey : key;
  },
);
